import { Button } from 'react-admin'
const MyButton = (props) => 
  <Button {...props}
    size="large"
    sx={{ margin: 1, bgcolor: '#eeeeee' }}
  />

export default MyButton